export default "__VITE_ASSET__ff30541a__"